module.exports = __webpack_public_path__ + "img/setup.a66ede3b.svg";